<template>
    <b-table
            :narrowed="true"
            :striped="true"
            default-sort="name"
            :data="data"
    >
     <template slot-scope="props">
         <b-table-column label="ID" width="40" numeric field="id" sortable>{{props.row.id}}</b-table-column>
         <b-table-column label="Name" field="name" sortable>
             <router-link :to="{path: '/configure/objects/' + props.row.id}">{{props.row.name}}</router-link>
         </b-table-column>
         <b-table-column label="Type" width="200" centered field="object_type_name" sortable>{{props.row.object_type_name}}</b-table-column>
     </template>
    </b-table>
</template>

<script>
  import BTableColumn from "buefy/src/components/table/TableColumn";

  export default {
    components: {BTableColumn},
    name: "object-list",
    props: ['list'],
    data() {
      return {
      };
    },
    computed: {
      data() {
        if (!this.list) {
          return [];
        }

        return this.list;
      }
    }
  }
</script>

<style scoped>

</style>